import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { QueueingSubject } from 'queueing-subject';
import { environment } from 'environments/environment';
import { connect } from '@app/common/websockets';
import { CLOUDDNS_RECEIVER_ID } from './clouddns-websockets.constant';

@Injectable({
  providedIn: 'root'
})
export class ClouddnsWebsocketsApi {

  status$: Observable<number>;
  messages$: Observable<string>;

  private _input = new QueueingSubject<string>();

  constructor(private _http: HttpClient) { }

  connect(token: string) {
    const endpoint = environment.production
      ? window.location.hostname
      : environment.cloudDnsWsUrl;

    const wsProtocol = !environment.production && environment.forceDevWsProtocol ?
      environment.forceDevWsProtocol
      : window.location.protocol === 'https:'
        ? 'wss'
        : 'ws';

    const { messages, connectionStatus } = connect(
      `${wsProtocol}://${endpoint}/clouddns/public-web-socket/${CLOUDDNS_RECEIVER_ID}/${token}`,
      this._input
    );

    this.messages$ = (messages as Observable<string>);
    this.status$ = connectionStatus;
  }

  send(value: string) {
    this._input.next(value);
  }

  auth$(accessToken: string) {
    return this._http.post<{ webSocketToken: string; }>(
      '/clouddns/public-web-socket/login',
      { accessToken }
    );
  }
}
